// based on served url to determined env.

export default function setEnv(location) {
    let env = "local";
    if (/alfred.camera/.test(location)) {
        env = "prod";
    }
    if (/wildlands.my-alfred.com/.test(location)) {
        env = "stage";
    }
    if (
        /(wildlands[2-9]{1}|beta[1-9]{1}).my-alfred.com/.test(location)
    ) {
        env = "dev";
    }

    // secret number for debugging in prodution
    const alfredTest2wsxsw2 =
        (env === 'dev' ||
        env === 'local' ||
        /debug=AlfredIsBest/.test(window.location.search)) &&
        (new URLSearchParams(window.location.search)).get("debug") !== "false"

    return {
        env,
        alfredTest2wsxsw2,
    };
}
